<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">

        <a-form :form="form" layout="vertical">
          <a-row :gutter="30" class="form-label">
            <a-col :md="10" :sm="24" :xs="24">
              <h4>账号：<span>{{ userInfo().username }}</span></h4>
            </a-col>
            <a-col :md="14" :sm="24" :xs="24">
              <h4>所属企业：<span>{{ userInfo().corpName }}</span></h4>
            </a-col>
          </a-row>

          <a-form-item label="姓名">
            <a-input
              :disabled="!editing"
              placeholder="请输入您的真实姓名"
              v-decorator="[
                'realname',
                {
                  initialValue: userInfo().realname,
                  rules: [{
                    min: 2, max: 20, message: '姓名限制2-20个字符'
                  }, {
                    required: true, message: '姓名不能为空'
                  }]
                }
              ]"/>
          </a-form-item>

          <a-form-item label="手机号码">
            <a-input :value="mobile" disabled/>
          </a-form-item>

          <a-form-item label="电子邮件">
            <a-input
              :disabled="!editing"
              placeholder="example@email.com"
              v-decorator="[
                'email',
                {
                  initialValue: userInfo().email,
                  rules: [{
                    type: 'email', message: '无效的E-mail地址'
                  }, {
                    required: true, message: '请输入E-mail地址'
                  }]
                }
              ]"/>
          </a-form-item>

          <a-form-item label="会员年龄">
            <p>{{ gmtCreate }}</p>
          </a-form-item>

          <a-form-item>
            <a-button v-if="!editing" type="primary" @click="editing=true">修改</a-button>
            <a-button v-if="editing" @click="editing=false">取消</a-button>
            <a-button v-if="editing" :loading="loading" type="primary" style="margin-left: 8px" @click="handleUpdate">保存</a-button>
          </a-form-item>
        </a-form>

      </a-col>
      <a-col :md="24" :lg="8" :style="{ minHeight: '180px' }">
        <div class="ant-upload-preview" @click="$refs.modal.edit(avatar(), avatarWidth, avatarHeight)">
          <a-icon type="cloud-upload-o" class="upload-icon"/>
          <div class="mask">
            <a-icon type="plus"/>
          </div>
          <img :src="avatar()"/>
        </div>
      </a-col>

    </a-row>

    <avatar-modal ref="modal" :user-id="userInfo().id">

    </avatar-modal>
  </div>
</template>

<script>
import AvatarModal from './AvatarModal'
import { blur } from '@/utils/util'
import { updateUser } from '@/api/user'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    AvatarModal
  },

  data () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      editing: false,
      avatarWidth: 150,
      avatarHeight: 150,
      mobile: blur(this.userInfo().mobile, 3, 7)
    }
  },

  computed: {
    gmtCreate () {
      const t = this.userInfo().gmtCreate
      if (t) {
        return this.moment(new Date()).from(new Date(t), true)
      } else {
        return '获取失败'
      }
    }
  },

  mounted () {
    const img = new Image()
    img.src = this.avatar()
    if (img.complete) {
      this.avatarWidth = img.width
      this.avatarHeight = img.height
    } else {
      const that = this
      img.onload = function () {
        that.avatarWidth = img.width
        that.avatarHeight = img.height
      }
    }
  },

  methods: {
    ...mapActions(['GetInfo']),
    ...mapGetters(['userInfo', 'avatar', 'roles']),

    moment,

    handleUpdate () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          values.mobile = this.userInfo().mobile
          values.corpId = this.userInfo().corpId
          values.roles = this.roles()
          updateUser(this.userInfo().id, values).then(response => {
            this.GetInfo().then(response => {
              this.$message.success(response.msg)
              this.editing = false
            }).catch(err => {
              console.log(err)
            }).finally(() => {
              this.loading = false
            })
          }).catch(err => {
            console.log(err)
          }).finally(() => {
            this.loading = false
          })
        } else {
          console.log(err)
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .form-label {
    margin-bottom: 4vh;

    span {
      color: rgba(0, 0, 0, 0.65);
      font-weight: 400;
    }
  }

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 150px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;

    .upload-icon {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 1.4rem;
      padding: 0.5rem;
      background: rgba(222, 221, 221, 0.7);
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .mask {
      opacity: 0;
      position: absolute;
      background: rgba(0, 0, 0, 0.4);
      cursor: pointer;
      transition: opacity 0.4s;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }

    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
